export default __webpack_public_path__ + "static/media/77t.6578b177.jpg";